import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommissionBasis } from '../../constants/commission';

export interface CommissionSettings {
  commission_basis: CommissionBasis;
  holding_days: number;
  // True while the owner has never saved settings (values are the defaults)
  is_default: boolean;
  updated_at: string | null;
  updated_by: string | null;
}

export interface CommissionSettingsState {
  settings: CommissionSettings | null;
  loading: boolean;
  saving: boolean;
  error: string | null;
}

const initialState: CommissionSettingsState = {
  settings: null,
  loading: false,
  saving: false,
  error: null,
};

const commissionSettingsSlice = createSlice({
  name: 'commissionSettings',
  initialState,
  reducers: {
    setCommissionSettingsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCommissionSettingsSaving: (state, action: PayloadAction<boolean>) => {
      state.saving = action.payload;
    },
    setCommissionSettingsError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setCommissionSettings: (state, action: PayloadAction<CommissionSettings>) => {
      state.settings = action.payload;
    },
  },
});

export const {
  setCommissionSettingsLoading,
  setCommissionSettingsSaving,
  setCommissionSettingsError,
  setCommissionSettings,
} = commissionSettingsSlice.actions;

export default commissionSettingsSlice.reducer;
